// bao migrate skip
import "./table-control.css";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
import 'devextreme/integration/jquery';
import 'devextreme/ui/data_grid';
import { Column, dxDataGridOptions } from 'devextreme/ui/data_grid';
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { exportDataGrid as XLSXExport } from "devextreme/excel_exporter";
import { exportDataGrid as PDFExport } from "devextreme/pdf_exporter";
import { saveAs } from 'file-saver';
import TableControlOData4Parser from "./table-control-odata-parser";
import jsPDF from "jspdf";
import { ApplicationIds } from "../../../core/application-ids";
const ExcelJS = require('exceljs');

// messages
const emptyCellMsg = Bao.Session.GetMessage("msgEmptyCell");
const countMsg = Bao.Session.GetMessage("msgCount");

export interface TableControlComponentParams {
    /**
     * Loads the data for the Table Control
     * @param skipParam Number of rows to skip
     * @param takeParam Number of rows to take
     * @param headerFilters Filters from the DevExtreme control
     * @param sortingParam Sorting from the DevExtreme control
     * @param groupingParam Grouping from the DevExtreme control
     * @param IsFilterRowVisible filter row visibility (row underneath the table headers)
     * @param IsEditColumnVisible toggles the edit pen visibility (right-hand column containing the edit button)
     * @param IsGroupingEnabled toggles the grouping functionality
     * @param IsExportEnabled toggles the export button visibility
     * @returns An object containing the data to be displayed and the total count 
     */
    loadTableControlData: (headerFilters: string, skipParam: number, takeParam: number, sortingParam: any[], groupingParam: any[]) => JQueryDeferred<{ data: any[], totalCount: number }>

    /**
     * Loads the ModelMetadata informations which are used to parse the oData Filter.
     * @returns ModelMetadata Informations
     */
    loadModelMetadata: () => JQueryDeferred<string>;

    /**
     * 
     * An optional custom function to be executed when the user clicks on the edit button for a given entry
     * @param rowData An object containing the row data
     */
    customEditEntryFunction: (rowData: object) => void;

    // Columns available for display
    AvailableColumns: KnockoutObservableArray<any>;

    // The parent of our TableControl (tab)
    Parent: any;

    // currently selected row
    Selection: KnockoutObservableArray<any>;

    // Unique key used for saving states and differentiating between TableControl instances
    TableControlKey: KnockoutObservable<string>;

    // Unique key used for loading data and differentiating between TableControl instances
    TableControlLoadKey: KnockoutObservable<string>;

    // Property to use as the key for the data (optional, default: SimpleSearchId)
    DataSourceKey: KnockoutObservable<string>;

    // specifies whether or not the filter row is visible
    IsFilterRowVisible: KnockoutObservable<boolean>;

    // specifies whether or not grouping is enabled
    IsGroupingEnabled: KnockoutObservable<boolean>;

    // specifies whether or not edit pen is visible (default: true)
    IsEditColumnVisible: KnockoutObservable<boolean>;

    // specifies whether or not export button is visible (default: true)
    IsExportEnabled: KnockoutObservable<boolean>;

    // specifies whether or not the data should be loaded automatically after the control was initialized
    AutoLoad: KnockoutObservable<boolean> | boolean;
}

export class TableControlComponent {
    DataGridHTML: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    Selection: KnockoutObservable<any> = ko.observable<any>();
    Params: TableControlComponentParams;
    EditLabel = ko.observable<string>('');
    IsFilterRowVisible = ko.observable<boolean>();
    IsEditColumnVisible = ko.observable<boolean>();
    TableControlODataParser: TableControlOData4Parser = new TableControlOData4Parser();
    DataGridDataSource: CustomStore;
    ModelMetadata: KnockoutObservable<string> = ko.observable();
    IsVirtualScrollingEnabled = ko.observable<boolean>();
    IsGroupingEnabled = ko.observable<boolean>();
    IsExportEnabled = ko.observable<boolean>();
    dataGridOptions: dxDataGridOptions = {
        dataSource: new CustomStore({
            // Default CustomStore to return empty results when the control is initialized
            // If no store is available at initialization of the control errors will be thrown.
            load: () => {
                return $.Deferred().resolve({
                    data: [],
                    groupCount: 0,
                    totalCount: 0
                }).promise();
            }
        }),
        allowColumnReordering: true,
        allowColumnResizing: true,
        wordWrapEnabled: true,
        columnAutoWidth: false,
        showBorders: false,
        remoteOperations:
        {
            groupPaging: true,
            filtering: true,
            grouping: true,
            paging: true,
            sorting: true,
            summary: true
        },
        rowAlternationEnabled: true,
        selection: {
            mode: "single"
        },
        onSelectionChanged: (selectedItems) => {

            if (typeof (this.Params.Selection) === 'function' && this.Params.Selection() != null) {
                this.Params.Selection.removeAll();

                if (selectedItems.selectedRowsData.length > 0) {
                    this.Params.Selection.push(selectedItems.selectedRowsData[0]);
                }                
            }
        },
        columnChooser: {
            enabled: true
        },
        columnFixing: {
            enabled: true
        },
        sorting: {
            mode: "multiple"
        },
        grouping: {
            expandMode: 'rowClick',
            autoExpandAll: false
        },
        scrolling: {
            mode: 'virtual',
            rowRenderingMode: 'virtual'
        },
        paging: {
            enabled: false
        },
        pager: {
            visible: false,
            allowedPageSizes: [20, 50, 100, 200],
            showPageSizeSelector: true,
            showInfo: false,
            showNavigationButtons: true
        },
        stateStoring: {
           enabled: true,
           type: "custom",
           customLoad: () => {
               return this.GetDataGridState();
           },
           customSave: (state) => {
               this.SetDataGridState(state);
           }
        },
        filterRow: {
            applyFilter: "auto",
            showOperationChooser: false
        },
        export: {
            allowExportSelectedData: false,
            //formats: ['pdf', 'xlsx']
        },
        onExporting: (e) => {

            const searchKey = this.Params.TableControlKey();

            if (e.format == 'pdf') {

                const doc = new jsPDF();
                const fileName = 'Export_' + searchKey.trim().split(' ').join("_") + '.pdf';

                PDFExport({
                    jsPDFDocument: doc,
                    component: e.component,
                }).then(function () {
                    doc.save(fileName);
                });
            }
            else if (e.format == 'xlsx') {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet(searchKey);

                Bao.post('Bao/GetServerTime').then((result) => {
                    const fileName = 'Export_' + searchKey.trim().split(' ').join("_") + "_" + result.Result + '.xlsx';
                    XLSXExport({
                        component: e.component,
                        worksheet: worksheet,
                        autoFilterEnabled: true
                    }).then(function () {
                        workbook.xlsx.writeBuffer().then(function (buffer) {
                            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
                        });
                    });
                });
            }

            e.cancel = true;
        },
        onCellPrepared: (e) => {
            if (e.rowType === "group" && e.value === "null") {
                e.cellElement.html(e.column.caption + ": " + ko.unwrap(emptyCellMsg) + " (" + ko.unwrap(countMsg) + " " + e.key.length + ")");
            }
        },
        onInitialized: (e) => {
            const gridInstance = e.component;

            gridInstance.option("filterRow.visible", this.Params.IsFilterRowVisible);
            gridInstance.option("groupPanel.visible", this.Params.IsGroupingEnabled);
            gridInstance.option("grouping.contextMenuEnabled", this.Params.IsGroupingEnabled);
            gridInstance.option("export.enabled", this.IsExportEnabled() && Bao.Session.HasPermission("SearchExport", ApplicationIds.Finito));

            this.UpdateAvailableColumns(this.Params.AvailableColumns());
            this.CheckUpdatesForAvailableColumns(this.Params.AvailableColumns());

            if (ko.unwrap(this.Params.AutoLoad)) {
                this.loadTableControlData(this.getUniqueTableControlKey());
            }
        },
        summary: {
            groupItems: [{
                column: 'Id',
                summaryType: 'count',
            }],
        }
    }

    SetDataGridState(state) {
        if (state?.pageIndex) {
            state.pageIndex = 0;
        }

        return Bao.post("Search/SaveDataGridState", JSON.stringify({
            searchKey: this.Params.TableControlKey(),
            state: JSON.stringify(state)
        }));
    }

    GetDataGridState() {
        return Bao.post("Search/GetDataGridState", JSON.stringify({
            searchKey: this.Params.TableControlKey()
        })).then((data) => {
            let result;
            try {
                result = JSON.parse(data);
            } catch {
                result = data;
            }
            return result;
        });
    }

    InitDataGridDataSource() {
        this.DataGridDataSource = new CustomStore({
            key: this.Params.DataSourceKey ? this.Params.DataSourceKey() : "SimpleSearchId",
            load: (loadOptions) => {
                let def = $.Deferred();
                let sortValue = loadOptions["sort"];
                let sortingParam = null;
                if (Array.isArray(sortValue)) {
                    sortingParam = sortValue.map((x: any) => { let obj = {}; obj['Column'] = x.selector; obj['Direction'] = x.desc === true ? 'Descending' : 'Ascending'; return obj; });
                }

                let groupValue = loadOptions["group"];
                let groupingParam = null;
                if (Array.isArray(groupValue)) {
                    groupingParam = groupValue.map((x: any) => { let obj = {}; obj['Column'] = x.selector; obj['Direction'] = x.desc === true ? 'Descending' : 'Ascending'; obj['IsExpanded'] = x.isExpanded; return obj; });
                }

                let skipParam = loadOptions["skip"];
                let takeParam = loadOptions["take"];

                if ((takeParam === 0 || takeParam === undefined) && !loadOptions["IsLoadingAll"]) {
                    const dataGridInstance = $(this.DataGridHTML()).dxDataGrid("instance");
                    takeParam = dataGridInstance.pageSize() || 20;
                    dataGridInstance.pageSize(takeParam);
                }

                // build filters from columns
                let headerFilters = this.TableControlODataParser.CreateODataFilterQuery(loadOptions?.filter, ko.unwrap(this.ModelMetadata));

                this.Params.loadTableControlData(headerFilters, skipParam, takeParam, sortingParam, groupingParam).then((loadResult) => {
                    def.resolve(loadResult);
                });
                return def.promise();
            }
        });
    }

    constructor(params: TableControlComponentParams, componentElement: HTMLElement) {

        this.Params = params;
        this.DataGridHTML(componentElement);
        this.EditLabel = Bao.Session.GetMessage("msgEdit");
        this.InitDataGridDataSource();
        this.InitControl();
        this.SetDxGridOptionsVisibilty();        

        this.Params.AvailableColumns.subscribe((newValue) => {
            this.CheckUpdatesForAvailableColumns(newValue);
            this.UpdateAvailableColumns(newValue);
        });

        this.Selection.subscribe(() => {
            if (this.Params.Parent != null) {
                this.Params.Parent.toggleButtons();
            }
        });
    }

    CheckUpdatesForAvailableColumns = (columns) => {
        if (columns) {
            columns.forEach((item, index) => {
                for (let column in item) {
                    if (ko.isObservable(item[column])) {
                        item[column].subscribe(() => {
                            this.UpdateAvailableColumns(this.Params.AvailableColumns());
                        });
                    }
                }
            });
        }
    }

    UpdateAvailableColumns = (newValue) => {
        let newColumns: Column[] = [];
        if (newValue) {                
            newValue.forEach((item, index) => {   
                let column: Column = this.PrepareNewColumn(item);

                if (ko.unwrap(item.Sortable) == false) {
                    column.allowSorting = false;
                }

                if (ko.unwrap(item.Filterable) == false) {
                    column.allowFiltering = false;
                }

                // handles fixed icons if this column is present
                if (ko.unwrap(item.PropertyName) == 'ColIcon') {
                    column.allowGrouping = false;
                    column.allowExporting = false;
                    column.allowReordering = false;
                    column.allowEditing = false;
                    column.allowFiltering = false;
                    column.allowSearch = false;
                    column.allowSorting = false;

                    // needed to force this column to the left
                    newColumns.unshift(column);
                }
                else {
                    newColumns.push(column);
                }
            });

            // Edit Column (right hand side column with pen icon rows)
            if (newColumns.length !== 0) {
                // buttons
                newColumns.push({
                    visible: this.IsEditColumnVisible(),
                    allowGrouping: false,
                    allowExporting: false,
                    allowReordering: false,
                    allowFiltering: false,
                    allowSearch: false,
                    allowSorting: false,
                    type: "buttons",    
                    width: 50,
                    buttons: [{
                        hint: ko.unwrap(this.EditLabel),
                        icon: "edit",
                        onClick: (e) => {
                            if (this.Params?.customEditEntryFunction) {
                                this.Params.customEditEntryFunction(e.row.data);
                            } else {
                                baoRouter.setHash(e.row.data.OpenUrl);
                            }
                            e.event.preventDefault();
                        }
                    }]
                });
            }
        }

        if (newColumns.length === 0) {
            $(this.DataGridHTML()).dxDataGrid({});
        }
        else {
            this.dataGridOptions.columns = newColumns;
            $(this.DataGridHTML()).dxDataGrid(this.dataGridOptions).dxDataGrid("instance");
        }
    };

    getUniqueTableControlKey = () => {
        return ko.unwrap(this.Params.TableControlLoadKey) ? ko.unwrap(this.Params.TableControlLoadKey) : ko.unwrap(this.Params.TableControlKey);
    }

    loadTableControlData = (key) => {
        if (ko.unwrap(key) == this.getUniqueTableControlKey()) {
            $(this.DataGridHTML()).dxDataGrid("instance").option("dataSource", new DataSource(this.DataGridDataSource));
        }
    }

    showEditColumn = (key) => {
        if (key == this.Params.TableControlKey()) {
            this.IsEditColumnVisible(true);

            let dataGrid = $(this.DataGridHTML()).data("dxDataGrid");

            if (dataGrid) {
                dataGrid.columnOption("buttons", "visible", true);
            }
        }
    }

    hideEditColumn = (key) => {
        if (key == this.Params.TableControlKey()) {
            this.IsEditColumnVisible(false);

            let dataGrid = $(this.DataGridHTML()).data("dxDataGrid");

            if (dataGrid) {
                dataGrid.columnOption("buttons", "visible", false);
            }
        }
    }

    getScrollingMode = () => {
        return Bao.post("FinitoSystemSetting/GetSystemSetting", JSON.stringify({
            key: 'DataGrid_IsVirtualScrollingEnabled'
        })).then((data) => {
            if (data != null) {
                this.IsVirtualScrollingEnabled(data.Value.toLowerCase() === "true");
            }
        });
    }

    InitControl() {
        Bao.bindEvent('table-control:load', this.loadTableControlData);
        Bao.bindEvent('table-control:show_edit_col', this.showEditColumn);
        Bao.bindEvent('table-control:hide_edit_col', this.hideEditColumn);

        this.getScrollingMode().then(() => {

            // Set scrolling and paging properties of the dxDataGridOptions based on the value of IsVirtualScrollingEnabled
            this.dataGridOptions.scrolling.mode = this.IsVirtualScrollingEnabled() ? 'virtual' : 'standard';
            this.dataGridOptions.scrolling.rowRenderingMode = this.IsVirtualScrollingEnabled() ? 'virtual' : 'standard';
            this.dataGridOptions.paging.enabled = !this.IsVirtualScrollingEnabled();
            this.dataGridOptions.pager.visible = !this.IsVirtualScrollingEnabled();

            // Reinitialize the grid with updated options
            $(this.DataGridHTML()).dxDataGrid(this.dataGridOptions);
            if (typeof this.Params.loadModelMetadata === 'function') {
                this.Params.loadModelMetadata().then(metadata => {
                    this.ModelMetadata(metadata);
                });
            }
        })
    }
 
    /**
     * Creates and returns a configured column
     * @param item The model that contains the data to configure the column
     * @returns Configured column
     */
    PrepareNewColumn = (item: any): Column => {
        const column: Column = {
            dataField: ko.unwrap(item.PropertyName),
            caption: ko.unwrap(item.HeaderText),
            visible: ko.unwrap(item.Visible),
            allowSorting: ko.unwrap(item.AllowSorting) !== false,
            allowFiltering: ko.unwrap(item.AllowFiltering) !== false,
            allowGrouping: ko.unwrap(item.AllowGrouping) !== false
        };

        if (ko.unwrap(item.CellTemplate)) {
            column.cellTemplate = function (container, options) {
                $("<div>")
                    .append(ko.unwrap(item.CellTemplate))
                    .appendTo(container);
            }
        }

        if (ko.unwrap(item.Width) > 0) {
            column.width = ko.unwrap(item.Width);
        }

        if (ko.unwrap(item.ColumnType)?.toLowerCase() === 'icon') {
            this.PrepareIconColumn(item, column);
        }
        else if (ko.unwrap(item.ColumnType)?.toLowerCase() === 'iconclass') {
            this.PrepareIconClassColumn(column);
        }
        else if (ko.unwrap(item.ColumnType)?.toLowerCase() === 'date') {
            column.dataType = "date";
        }
        else if (ko.unwrap(item.ColumnType)?.toLowerCase() === 'datetime') {
            column.dataType = "datetime";
        }
        else if (ko.unwrap(item.ColumnType)?.toLowerCase() === 'decimal') {
            column.dataType = "number";
            column.format = {
                type: "fixedPoint",
                precision: 2
            };
        }
        else if (ko.unwrap(item.ColumnType)?.toLowerCase() === 'editlink') {
            column.cellTemplate = (container, options) => {
                $('<a/>').addClass('dx-link')
                    .text(options.displayValue)
                    .on('dxclick', () => {
                        baoRouter.setHash(options.data.OpenUrl);
                    })
                    .appendTo(container);
            }
        }

        // turn off HTML encoding for specific columns
        if (ko.unwrap(item.DisplayAsHtml) || ko.unwrap(item.ColumnType) == 'icon') {
            column.encodeHtml = false;
        }

        if (ko.unwrap(item.Groupable) == false) {
            column.allowGrouping = false;
        }

        return column;
    }

    /**
     * Icon column configuration
     * @param item Column model
     * @param column The column object to be configured for the Icon type column
     */
    protected PrepareIconColumn = (item: any, column: Column): void => {
        column.allowExporting = false;
        column.allowHeaderFiltering = false;
        if (item.CellTemplate) {
            column.cellTemplate = function (container, options) {
                const template = $("<div>");
                if (options.value)
                    template.append(item.CellTemplate)
                template.appendTo(container);
                return template;
            }
        }
    }

    /**
     * IconClass column configuration
     * @param column The column object to be configured for the IconClass type column
     */
    protected PrepareIconClassColumn = (column: Column): void => {
        column.allowExporting = false;
        column.allowHeaderFiltering = false;
        column.alignment = 'center';
        column.cellTemplate = function (container, options) {
            const template = $("<i/>");
            if (options.value) {
                template.addClass(options.value);
            }
            template.appendTo(container);
            return template;
        }
    }

    /**
     * Method to set dx grid icons visibilty
     */
    protected SetDxGridOptionsVisibilty(){
        this.IsExportEnabled(typeof(this.Params.IsExportEnabled) === "boolean" && !this.Params.IsExportEnabled ? false : true);
        this.IsEditColumnVisible(typeof(this.Params.IsEditColumnVisible) === "boolean" && !this.Params.IsEditColumnVisible ? false : true);
    }
}